import { Box, Drawer, DrawerProps, styled, useTheme } from "@mui/material";
import { useCheckViewPoint } from "hooks/useCheckViewPoint";

export const CHAIN_ABBREVIATION_MAP: Record<string, string> = {
  solana: "SOL",
  ethereum: "ETH",
  base: "BASE",
  ton: "TON",
  ton_testnet: "TON",
};

export type NumpadKey = "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "0" | "." | "delete";

const StyledDrawer = styled(Drawer)({
  background: "transparent",
  "& .MuiDrawer-paper": {
    background: "transparent",
    display: "flex",
  },
});

export const buttonConfig = [
  {
    label: "10%",
    value: 0.1,
  },
  {
    label: "25%",
    value: 0.25,
  },
  {
    label: "50%",
    value: 0.5,
  },
  {
    label: "MAX",
    value: 1,
  },
];

export const DarkDrawer = ({ children, ...props }: DrawerProps) => {
  const theme = useTheme();
  const isMobile = useCheckViewPoint({ to: "md" });

  return (
    <StyledDrawer
      PaperProps={
        isMobile
          ? {}
          : {
              sx: { paddingX: "24px", maxWidth: "1200px", marginX: "auto" },
            }
      }
      {...props}>
      <Box
        sx={{
          background: theme.palette.surface.container,
          border: `1px solid ${theme.palette.border.dark}`,
          borderTopLeftRadius: theme.spacing(3),
          borderTopRightRadius: theme.spacing(3),
          padding: theme.spacing(2.5),
          flex: 1,
        }}>
        {children}
      </Box>
    </StyledDrawer>
  );
};
